import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { drawerContentAdapter } from './content-drawer.selectors';
import { searchDrawerContents } from './content-drawer.thunk';
import { DrawerContentState } from './content-drawer.types';

export const drawerContentState: DrawerContentState = drawerContentAdapter.getInitialState({
  metadata: {
    total: 0,
    offset: 0,
    limit: 20,
    loading: false,
    isFiltering: false,
    next: null,
  },
  error: null,
});

export const { actions: drawerContentActions, reducer: drawerContentReducer } = createSlice({
  name: 'drawer-contents',
  initialState: drawerContentState,
  reducers: {},
  extraReducers: (builder) => {
    // searchContents
    builder.addCase(searchDrawerContents.pending, (state) => {
      state.metadata.loading = true;
    });
    builder.addCase(searchDrawerContents.fulfilled, (state, action) => {
      const drawerContents = action.payload.items.map((item) => ({
        ...item,
        uiId: uuidv4(),
      }));

      if (action.meta.arg.offset === 0) {
        drawerContentAdapter.setAll(state, drawerContents);
      } else {
        drawerContentAdapter.addMany(state, drawerContents);
      }

      state.metadata.loading = false;
      state.metadata.total = action.payload.metadata.total;
      state.error = null;
    });
    // TODO: handle errors
  },
});
